@if (isLoading) {
  <app-loader></app-loader>
}@else {
  <app-doc-viewer [filePath]="data.filePath" [isFilePreview]="true"></app-doc-viewer>
}
